module.exports = __webpack_public_path__ + "static/media/PPN App - ABN Network - 21-03-2025 N.0a422eb6.gif";